module.exports = __webpack_public_path__ + "img/ch09_02_若依看呆.6f14cc78.jpg";